export const bensRoute: string = 'bens';
export const bensModuleName: any = {plural: 'Bens', single: 'Bem'};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/shared/data.service.ts
 **/